import { TileSetMapType, CHARACTER_DIRECTION } from "common/model";

const landscapeLayer1 = [
  [23, 22, 22, 22, 22],
  [31, 31, 31, 31, 26],
  [31, 31, 23, 31, 26],
  [26, 31, 31, 31, 26],
  [22, 22, 22, 22, 26],
];
const landscapeLayer2 = [
  [42, 1, 0, 0, 0],
  [0, 0, 0, 0, 13],
  [0, 0, 36, 0, 13],
  [13, 0, 0, 0, 13],
  [0, 0, 0, 0, 13],
];
const landscapeLayer3 = [
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
  [8, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
];

const landscape = [landscapeLayer1, landscapeLayer2, landscapeLayer3];

const map: TileSetMapType = {
  character: {
    direction: CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_X,
  },
  landscape: landscape,
};

export default map;
